import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import TournamentCard from "@/components/TournamentCard";
import api from "@/lib/api";

const DIVISIONS = [
  { key: "state", label: "State", color: "bg-jpa-primary text-white" },
  { key: "national", label: "National", color: "bg-jpa-secondary text-white" },
  { key: "international", label: "International", color: "bg-jpa-ink text-white" },
];
const STATUSES = [
  { key: "upcoming", label: "Upcoming", color: "bg-jpa-accent text-jpa-ink" },
  { key: "running", label: "Running", color: "bg-jpa-live text-white" },
  { key: "past", label: "Past", color: "bg-jpa-ink text-white" },
];

export default function TournamentsPage() {
  const [items, setItems] = useState([]);
  const [division, setDivision] = useState("state");
  const [status, setStatus] = useState("upcoming");

  useEffect(() => { api.get("/tournaments").then((r) => setItems(r.data)); }, []);

  const byDivision = items.filter((t) => t.division === division);
  const filtered = byDivision.filter((t) => t.status === status);
  const countByStatus = (s) => byDivision.filter((t) => t.status === s).length;
  const countByDivision = (d) => items.filter((t) => t.division === d).length;

  return (
    <div data-testid="tournaments-page">
      <PageHero
        eyebrow="Official calendar"
        title="TOURNAMENTS"
        subtitle="From district qualifiers to international pro circuits — every event that shapes the JPA rankings."
        image="https://images.unsplash.com/photo-1617144520113-88ae706a86eb?w=1800"
      />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        {/* Division tabs */}
        <div data-testid="division-tabs" className="inline-flex items-center gap-1 bg-jpa-surface rounded-sm p-1 flex-wrap">
          {DIVISIONS.map((d) => (
            <button
              key={d.key}
              data-testid={`division-${d.key}`}
              onClick={() => setDivision(d.key)}
              className={`uppercase tracking-widest text-sm font-bold rounded-sm px-6 py-2 transition-colors ${
                division === d.key ? d.color : "text-jpa-ink hover:text-jpa-primary"
              }`}
            >
              {d.label} ({countByDivision(d.key)})
            </button>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-3">
          <span className={`inline-block w-3 h-3 rounded-full ${DIVISIONS.find((x) => x.key === division).color.split(" ")[0]}`} />
          <h2 className="font-display text-3xl tracking-wider">{DIVISIONS.find((x) => x.key === division).label} Division</h2>
        </div>

        {/* Status tabs */}
        <div className="mt-4 inline-flex items-center gap-1 border border-jpa-border bg-white rounded-sm p-1 flex-wrap">
          {STATUSES.map((s) => (
            <button
              key={s.key}
              data-testid={`tab-${s.key}`}
              onClick={() => setStatus(s.key)}
              className={`uppercase tracking-widest text-sm font-bold rounded-sm px-5 py-2 transition-colors ${
                status === s.key ? s.color : "text-jpa-ink hover:text-jpa-primary"
              } ${status === s.key && s.key === "running" ? "live-pulse" : ""}`}
            >
              {s.label} ({countByStatus(s.key)})
            </button>
          ))}
        </div>

        <div className="mt-6">
          {filtered.length === 0 ? (
            <div className="py-16 text-center text-jpa-muted">No {status} tournaments in the {division} division.</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((t) => <TournamentCard key={t.id} t={t} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
